angular.module('Itao.IndicatorMap').directive('districtsPieChart', function (d3, mapConfig) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var color = d3.hyperion.indicatorColorAt;

  var combineData = function (layer, indicator, selectedDistricts, disabledDistricts) {
    if (indicator == null) {
      return [];
    }
    var selectedUids = selectedDistricts.map(function (district) {
      return district.uid;
    });
    var data = [];
    for (var districtUid in layer.districts) {
      if (layer.hasOwnProperty(districtUid)) {
        var value = disabledDistricts.indexOf(layer.districts[districtUid].key) === -1 ? +layer[districtUid][indicator.uid] : 0;
        data.push({
          key: layer.districts[districtUid].key,
          name: layer.districts[districtUid].name,
          value: value,
          selected: selectedUids.indexOf(districtUid) !== -1
        });
      }
    }
    return data;
  };

  var districtsPieChart = function () {
    var indicator = {},
      districtColorFunction = function () {
        return '';
      },
      svgHeight = 200,
      margin = {top: 20, right: 10, bottom: 40, left: 50},
      duration = 400,
      numberFormat = germanNumberFormat(',.2f'),
      tip;

    var chart = function (selection) {
      selection.each(function (data) {

        var container = d3.select(this).datum([data]).classed('districts-pie-chart', true);

        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        var sum = d3.sum(data, accessor('value'));

        if (angular.isDefined(tip)) {
          tip.destroy();
        }

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function (d) {
            var centroid = labelArc.centroid(d);
            var bbox = this.getBBox();
            // open tip above labels
            return [centroid[1] - bbox.y - 17, centroid[0] - bbox.x - (bbox.width / 2)];
          })
          .html(function (d) {
            var value;
            if (indicator.unit) {
              value = numberFormat(d.data.value) + indicator.unit;
            } else {
              value = d.value + ' (' + numberFormat((d.value / sum) * 100) + '%)';
            }
            return '<div class="d3-tip-border" style="border-color:' + districtColorFunction(d.data) + ';"><b>' + d.data.name + ' (' + d.data.key + ')</b><br><span style="color:' + districtColorFunction(d.data) + ';">' + indicator.name + ':</span> <span>' + value + '</span></div>';
          });

        var svg = container.selectAll('svg').data([data]);

        svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);

        g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + (margin.left + width / 2) + ',' + (margin.top + height / 2) + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        var pieRadius = Math.min(width, height) / 2;
        var pieLayout = d3.layout.pie()
          .value(accessor('value'))
          .sort(null);

        var arc = d3.svg.arc()
          .innerRadius(0)
          .outerRadius(pieRadius);

        function arcTween(a) {
          var i = d3.interpolate(this._current, a);
          this._current = i(0);
          return function (t) {
            return arc(i(t));
          };
        }

        function labelTransformTween(a) {
          var i = d3.interpolate(this._current, a);
          this._current = i(0);
          return function (t) {
            return 'translate(' + labelArc.centroid(i(t)) + ')';
          }
        }

        var labelArc = d3.svg.arc()
          .innerRadius(pieRadius / 2)
          .outerRadius(pieRadius);

        // only draw bars if indicators are left
        if (angular.isObject(indicator) && indicator.hasOwnProperty('key')) {

          var features = g.selectAll('.feature')
            .data(pieLayout(data), function (d) {
              return d.data.key;
            });

          features.enter()
            .append('g')
            .attr('class', 'feature');

          var arcs = features.selectAll('path')
            .data(function (d) {
              return [d];
            }, function (d) {
              return d.data.key;
            });

          arcs.enter().append('path')
            .each(function (d) {
              this._current = d;
            });

          arcs.transition().duration(duration)
            .attrTween('d', arcTween)
            .attr('fill', function (d) {
              return districtColorFunction(d.data);
            });

          var labels = features.selectAll('text')
            .data(function (d) {
              return [d];
            }, function (d) {
              return d.data.key;
            });

          labels.enter().append('text')
            .each(function (d) {
              this._current = d;
            });

          labels
            .text(function (d) {
              var value;
              if (d.endAngle - d.startAngle < 80 / pieRadius) {
                // exclude labels on small arcs
                return '';
              }
              if (indicator.unit) {
                value = numberFormat(d.data.value) + indicator.unit;
              } else {
                value = d.value;
              }
              return value;
            })
            .transition().duration(duration)
            .attrTween('transform', labelTransformTween);

          // add tooltips to bars
          arcs.call(tip);
          arcs.on('mouseover', tip.show)
            .on('mouseout', tip.hide);

          arcs.exit().remove();
          labels.exit().remove();
          features.exit().remove();

        } else {
          g.selectAll('path').remove();
          g.selectAll('text').remove();
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicator] set of new indicators
     * @returns {*}
     */
    chart.indicator = function (newIndicator) {
      if (!arguments.length) {
        return indicator;
      } else {
        indicator = newIndicator;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for districtColorFunction
     * @param {Function} [newDistrictColorFunction] function to get a color from a district
     * @returns {*}
     */
    chart.districtColorFunction = function (newDistrictColorFunction) {
      if (!arguments.length) {
        return districtColorFunction;
      } else {
        districtColorFunction = newDistrictColorFunction;
        return chart;
      }
    };


    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return tip;
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element) {
    return element.closest('.grid-stack-item-content-districtsPieChart').height() - jQuery(element).find('chart-district-legend').height() - 10;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'districtsPieChart.html',
    scope: {
      layer: '=',
      selectedDistricts: '=',
      indicators: '=',
      dimensionX: '@',
      dimensionY: '@',
      config: '='
    },
    link: function (scope, element) {
      scope.config.indicatorToShow = scope.config.indicatorToShow || '';
      scope.config.disabledDistricts = scope.config.disabledDistricts || [];
      scope.config.fullscreen = scope.config.fullscreen || false;

      var districtsPieChartFunction = districtsPieChart();
      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if (newHeight == null) {
          newHeight = calculateChartHeight(element);
        }

        var indicatorToShow = scope.indicators.filter(function (indicator) {
          return indicator.hasShapeData && indicator.key === scope.config.indicatorToShow;
        })[0];


        var districtColorFunction = (function (districtObject) {
          var keys = Object.keys(districtObject).map(function (d) {
            return districtObject[d].key;
          });
          return function (d) {
            return color(keys.indexOf(d.key));
          }
        })(scope.layer.districts);

        scope.districtColorFunction = districtColorFunction;

        var data = combineData(scope.layer, indicatorToShow, scope.selectedDistricts, scope.config.disabledDistricts);

        districtsPieChartFunction
          .indicator(indicatorToShow)
          .districtColorFunction(districtColorFunction)
          .height(newHeight);
        d3.select(element.find('.chart-wrap')[0])
          .data([data])
          .call(districtsPieChartFunction);
      };

      var layerWatcher = scope.$watch('layer', rerender);
      var indicatorWatcher = scope.$watchCollection('indicators', function (newValue, oldValue, scope) {
        if (angular.isArray(newValue) && newValue.length > 0) {
          if (scope.config.indicatorToShow === ''
            || scope.config.indicatorToShow == null
            || newValue.map(function (d) {
              return d.key;
            }).indexOf(scope.config.indicatorToShow) === -1) {
            // select first as default
            scope.config.indicatorToShow = newValue[0].key;
          }
        } else {
          scope.config.indicatorToShow = '';
        }
        rerender();
      });
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var indicatorToShowWatcher = scope.$watch('config.indicatorToShow', rerender);
      var disabledDistrictsWatcher = scope.$watchCollection('config.disabledDistricts', rerender);
      var selectedDistrictsWatcher = scope.$watchCollection('selectedDistricts', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);

      var legendHeightWatcher = scope.$watch(function () {
        return calculateChartHeight(element);
      }, function (newValue, oldValue) {
        if (newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });
      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        indicatorToShowWatcher();
        disabledDistrictsWatcher();
        selectedDistrictsWatcher();
        fullscreenWatcher();

        // remove tooltip dom element
        if (angular.isDefined(districtsPieChartFunction.tip())) {
          districtsPieChartFunction.tip().destroy();
        }
      });
    }
  };
});
